
import { defineComponent, onMounted, ref } from "vue";
import ApiService from "@/core/services/ApiService";
import UserAvatar from "@/components/UserAvatar.vue";
import Notice from "@/components/Notice.vue";
export default defineComponent({
  name: "kt-referred-users",
  components: {
    UserAvatar,
    Notice,
  },
  setup() {
    const loading = ref(true);
    const list = ref();
    const pagination = ref();

    const filterData = ref({
      with_commission: true,
      sort: "",
      page: 1,
      has_agent: true,
    });

    const getList = () => {
      loading.value = true;
      ApiService.query("admin/user", { params: filterData.value })
        .then(({ data }) => {
          loading.value = false;
          list.value = data.data.users.data;
          pagination.value = data.data.users.pagination;
        })
        .catch(() => {
          loading.value = false;
        });
    };

    onMounted(() => {
      getList();
    });

    const handleCurrentChange = (val: number) => {
      filterData.value.page = val;
      getList();
    };

    return {
      list,
      loading,
      pagination,
      handleCurrentChange,
    };
  },
});
